(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name IncidenceService
     *@description
     *Servicio de la página "Reportar incidencia"
     */

    angular
        .module('appback')
        .factory('IncidenceService', IncidenceService);

    IncidenceService.$inject = ["$http"];

    function IncidenceService($http) {

        var service = {
            GetFormData: GetFormData,
            GetCameras: GetCameras,
            GetLocationTemplates: GetLocationTemplates,
            GetCameraFrame: GetCameraFrame,
            ReportIncidence: ReportIncidence
        };

        function GetFormData() {
            return $http.get('/backend/incidence/get-form-data', {
                headers: {}
            }).then(function (response) {
                return response.data;
            });
        }

        function GetCameras(lineId) {
            return $http.get('/backend/incidence/get-cameras', {
                params: { line: lineId }
            }).then(function (response) {
                return response.data;
            });
        }

        function GetLocationTemplates(machineId) {
            return $http.get('/backend/incidence/get-location-templates', {
                params: { machine: machineId }
            }).then(function (response) {
                return response.data;
            });
        }

        // Captura actual de una cámara a resolución completa, como Blob.
        function GetCameraFrame(camera) {
            return $http.get('/backend/incidence/camera-frame', {
                params: {
                    camera: camera,
                    cache: Date.now()
                },
                responseType: 'blob'
            }).then(function (response) {
                return response.data;
            });
        }

        // Datos del reporte (JSON) e imágenes (File o Blob) en una sola petición multipart.
        function ReportIncidence(data, images) {

            var formData = new FormData();

            formData.append('data', JSON.stringify(data));

            angular.forEach(images || [], function (image) {
                formData.append('images[]', image.file, image.name);
            });

            // Content-Type undefined: el navegador pone multipart/form-data con
            // su boundary. El token CSRF lo añade la configuración global.
            return $http.post('/backend/incidence/report-incidence', formData, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (response) {
                return response.data;
            });
        }

        return service;
    }
})();
